import {
  BottomSheetComponent,
  hideHeader,
  Modal,
  NavigationConfig,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@betty/navigation';
import { DailyScratcherScreen } from '../screens';
import DailyScratcherAwardedBottomSheet from './DailyScratcherAwardedBottomSheet/DailyScratcherAwardedBottomSheet';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'DailyScratcher',
      options: hideHeader,
      component: DailyScratcherScreen,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheets = {
  DailyScratcherAwardedBottomSheet,
};

registerBottomSheets('dailyScratcher', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    dailyScratcher: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

registerNavigationHandlers<AppNavigatorParamsList, 'DailyScratcher'>({
  DailyScratcher() {
    Modal.open({
      namespace: 'dailyScratcher',
      type: 'DailyScratcher',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        borderRadius: 'radius-400',
      },
    });
  },
});
